import { CandidateFormSkeleton } from '@/shared/components/candidate-form/components/candidate-form.skeleton';
import { ErrorPage } from '@/shared/components/error-page/error-page';
import { ApplicationFormStatus } from '../shared/application-form-status';
import { useCreateSession } from '../shared/hooks/use-create-session';
import { CandidateAnswerForm } from './answer-form/candidate-answer-form.page';
import { useAddResourceBundle } from './i18n/use-add-resource-bundle';
import { useTranslationPublicCandidateForm } from './i18n/use-translations';
import type { TPageLoaderData } from './types';

export const CandidateForm = ({
  loaderData,
}: {
  loaderData: TPageLoaderData;
}) => {
  useAddResourceBundle();
  const { t } = useTranslationPublicCandidateForm();

  const organizationId =
    'vacancy' in loaderData
      ? loaderData.vacancy.centralized_organization_id
      : undefined;

  const {
    loading: loadingSession,
    error: ErrorSession,
    createSession,
  } = useCreateSession(organizationId);

  if ('error' in loaderData) {
    if (loaderData.error === 'not-found') {
      return (
        <div className="tw-h-[100vh]">
          <ApplicationFormStatus
            title={t('CANDIDATE_FORM_STATUS_TITLE_NOT_FOUND')}
            description={t('CANDIDATE_FORM_STATUS_DESCRIPTION_NOT_FOUND')}
            type="not-found"
          />
        </div>
      );
    }

    return (
      <div className="tw-h-[100vh]">
        <ErrorPage
          title={t('ERROR_PAGE_TITLE_CANDIDATE_FORM')}
          description={t('ERROR_PAGE_DESCRIPTION_CANDIDATE_FORM')}
          buttonText={t('RETRY')}
          refreshAction={() => window.location.reload()}
        />
      </div>
    );
  }

  if (loadingSession) {
    return <CandidateFormSkeleton />;
  }

  // Display an error page if there is an error
  if (ErrorSession) {
    return (
      <div className="tw-h-[100vh]">
        <ErrorPage
          title={t('ERROR_PAGE_TITLE_CANDIDATE_FORM')}
          description={t('ERROR_PAGE_DESCRIPTION_CANDIDATE_FORM')}
          buttonText={t('RETRY')}
          refreshAction={() => createSession(organizationId)}
        />
      </div>
    );
  }

  return (
    <CandidateAnswerForm
      vacancy={loaderData.vacancy}
      organization={loaderData.organization}
    />
  );
};
